var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGritIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gritIcon",
    width: 221,
    height: 220,
    viewBox: "20.5 15 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_98_2029)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 55C20.5 32.9086 38.4086 15 60.5 15C82.5914 15 100.5 32.9086 100.5 55C100.5 77.0914 82.5914 95 60.5 95C38.4086 95 20.5 77.0914 20.5 55Z",
    fill: "#BDBDFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_2029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2048 43.0952H79.0362",
    stroke: "#330072",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2048 50.7144H78.7952",
    stroke: "#330072",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2048 58.3333H78.5714",
    stroke: "#330072",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2048 65.9524H78.5714",
    stroke: "#330072",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6191 73.5714V36.2048",
    stroke: "#330072",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0476 73.0951V36.4285",
    stroke: "#330072",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5715 74.0476V35.9639",
    stroke: "#330072",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7109 36.4458H41.4458V43.1928H47.7109V36.4458Z",
    fill: "#330072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.426 58.6145H69.526C69.189 58.6145 68.9158 58.9421 68.9158 59.3463V65.1116C68.9158 65.5158 69.189 65.8434 69.526 65.8434H78.426C78.7631 65.8434 79.0363 65.5158 79.0363 65.1116V59.3463C79.0363 58.9421 78.7631 58.6145 78.426 58.6145Z",
    fill: "#330072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1429 35.9524H42.8572C41.8052 35.9524 40.9524 36.8052 40.9524 37.8572V72.1429C40.9524 73.1948 41.8052 74.0476 42.8572 74.0476H77.1429C78.1948 74.0476 79.0476 73.1948 79.0476 72.1429V37.8572C79.0476 36.8052 78.1948 35.9524 77.1429 35.9524Z",
    stroke: "#330072",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGritIcon);
export default __webpack_public_path__ + "static/media/gritIcon.250853b20260083d2eb1fa7b147393e9.svg";
export { ForwardRef as ReactComponent };